class DisplayInvestmentProductPartDetailsController {
  /*@ngInject*/
  constructor() {
    this.name = 'display-investment-product-part-details'
  }
}

export default DisplayInvestmentProductPartDetailsController
